// extracted by mini-css-extract-plugin
export default {"input-fields":"booking_input-fields__G1SY2","guests-menu-card":"booking_guests-menu-card__RO633"};